// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"264": "870f04195edf6afb","70": "ae308a2f4a571c89",}[chunkId] + ".bundle.js"
}